module.exports = __webpack_public_path__ + "img/ETH.180559c6.png";